module.exports = __webpack_public_path__ + "img/bathroom.abb01076.jpg";